import { Icon, Modal } from "pepsico-ds";
import { useState } from "react";
import "./partnerCodeGroupTypeSelector.scss";

export const PartnerCodeGroupTypeSelector = ({ isOpen, onSelect, onClose }) => {
  const [codeGroupType, setCodeGroupType] = useState(null);
  return (
    <Modal
      className="partner-code-group-type-selector-modal"
      showModal={isOpen}
      onCloseModal={onClose}
      title="Choose a Digital Reward Group type"
      primaryButtonProps={{
        size: "medium",
        text: "Select",
        variant: "primary",
        onClick: () => {
          if (codeGroupType) {
            onSelect(codeGroupType);
          }
        },
      }}
      secondaryButtonProps={{
        size: "medium",
        text: "Cancel",
        variant: "secondary",
        onClick: onClose,
      }}
      showTertiaryButton={false}
      showLink={false}
    >
      <div>
        <div className="partner-code-group-type-selector">
          <div
            className={`card ${codeGroupType === "UPLOAD_LIST" ? "selected" : ""}`}
            onClick={() => setCodeGroupType("UPLOAD_LIST")}
          >
            <Icon icon="upload" />
            <h3>Upload List of Codes/Links</h3>
            <p>Upload a CSV file containing unique codes or links.</p>
          </div>
          <div
            className={`card ${codeGroupType === "UNLIMITED_CODE" ? "selected" : ""}`}
            onClick={() => setCodeGroupType("UNLIMITED_CODE")}
          >
            <Icon icon="link" />
            <h3>Single Unlimited Code/Link</h3>
            <p>
              Enter a single code or link that can be redeemed by unlimited users.
            </p>
          </div>
        </div>
      </div>
    </Modal>
  );
};
